// extracted by mini-css-extract-plugin
export var active = "styles-module--active---D+CQ";
export var isLast = "styles-module--is-last--6GD31";
export var lanHolder = "styles-module--lan-holder--g2GSY";
export var lanLink = "styles-module--lan-link--Nuk5m";
export var menuDesktop = "styles-module--menu-desktop--CNsrL";